import { useQuery, useMutation, useQueryClient } from '../lib/queryClient';
import { toast } from 'sonner';
import { getFavoritesList } from '../endpoints/favorites/list_GET.schema';
import { toggleFavorite } from '../endpoints/favorites/toggle_POST.schema';

export const useFavorites = () => {
  return useQuery({
    queryKey: ['favorites', 'list'],
    queryFn: () => getFavoritesList(),
    retry: 1,
  });
};

export const useFavoriteStatus = (sessionId: string | undefined) => {
  const { data, isLoading } = useFavorites();

  const isFavorited = (data?.favorites ?? []).some((f) => f.sessionId === sessionId);

  return {
    isFavorited,
    isLoading,
  };
};

export const useToggleFavorite = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: toggleFavorite,
    onSuccess: (data) => {
      if (data.favorited) {
        toast.success('Added to favorites');
      } else {
        toast.success('Removed from favorites');
      }
      queryClient.invalidateQueries({ queryKey: ['favorites', 'list'] });
    },
    onError: (error) => {
      toast.error(`Failed to update favorite: ${error.message}`);
    },
  });
};
